import find from "lodash/find"
import ReactPlayer from "react-player"
import getContentUrl from "utils-lib/getContentUrl"
import { white } from "constants-lib/colors"
import { KEY_CODE_MAPPING } from "constants-lib/keyCodes"
import withRouter from "hoc-lib/router"
import { isTeamsitePage } from "utils-lib/isTeamsitePage"
import { isMyWMApp } from "utils-lib/isMyWMApp"
import { getWindow } from "utils-lib/getWindow"
import { ButtonArrow } from "../../../../Base"

const ssrWindow = getWindow()

const DetailsPane = ({
  data,
  onMenuClick,
  megaNavSelection,
  setParentState,
  router,
}) => {
  if (!data) {
    return null
  }
  return (
    <div className="MegaNav__right" data-testid="DetailsPane">
      <div className={`${!data.featuredContentImage ? `d-none` : ``}`}>
        {data.featuredContentImage.indexOf(`.mp4`) !== -1 ? (
          <ReactPlayer
            height={172}
            width={306}
            url={data.featuredContentImage}
            config={{
              youtube: {
                embedOptions: {
                  host: "https://www.youtube-nocookie.com",
                },
              },
            }}
            controls
          />
        ) : (
          <div
            className="w-100 d-flex justify-content-center"
            style={{ overflow: `hidden` }}
          >
            <img
              alt="details pane"
              src={getContentUrl(data.featuredContentImage)}
              style={{
                backgroundColor: white,
                height: 172,
              }}
            />
          </div>
        )}
      </div>
      <div className="w-100" style={{ height: `127px` }}>
        <div className="detailsPane_title maax-font-weight-bold mt-4">
          {data.featuredContentHeading}
        </div>
        <div className="mt-2 mb-3 maax-font-weight-regular detailsPane_description">
          {data.featuredContentBody}
        </div>
        {data.featuredContentCtaText ? (
          <ButtonArrow
            isExternalLink={
              isMyWMApp || isTeamsitePage(ssrWindow.location.pathname)
            }
            href={data.featuredContentCtaUrl}
            isBackgroundGreen
            onClick={() => {
              onMenuClick(false)
            }}
            onKeyDown={(e) => {
              /* handle spacebar event */
              if (e.keyCode === KEY_CODE_MAPPING.SPACE_BAR) {
                if (isMyWMApp || isTeamsitePage(ssrWindow.location.pathname)) {
                  router.push(data.featuredContentCtaUrl)
                  setParentState({
                    megaNavSelection: ``,
                  })
                } else {
                  ssrWindow.location.pathname = data.featuredContentCtaUrl
                }
              }

              /* shift focus back to the next menu item */
              if (e.keyCode === KEY_CODE_MAPPING.TAB && !e.shiftKey) {
                e.preventDefault()

                const menuItems = Array.from(
                  ssrWindow.document.querySelectorAll(`.menu-item__text`),
                )

                let itemIndex = 0
                // eslint-disable-next-line consistent-return
                find(menuItems, (item, i) => {
                  if (item.innerHTML === megaNavSelection) {
                    itemIndex = i

                    return true
                  }
                })

                let nextMenuItem = ssrWindow.document.querySelector(
                  `.MenuItem:nth-child(${itemIndex + 2}) > .menu-item > button`,
                )

                if (!nextMenuItem) {
                  nextMenuItem = ssrWindow.document.querySelector(
                    `.MenuItem:nth-child(${itemIndex + 2}) > .menu-item > a`,
                  )
                }

                if (nextMenuItem) {
                  if (itemIndex === menuItems.length - 2) {
                    setParentState({ megaNavSelection: `` })
                  }

                  nextMenuItem.focus()
                }
              }
            }}
            target="_blank"
            rel="noopener noreferrer"
            key="1"
            className="quick-items pb-2"
          >
            {data.featuredContentCtaText}
          </ButtonArrow>
        ) : null}
      </div>
    </div>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// DetailsPane.propTypes = {
//   data: PropTypes.object.isRequired,
//   onMenuClick: PropTypes.func.isRequired,
//   megaNavSelection: PropTypes.string.isRequired,
//   setParentState: PropTypes.func.isRequired,
//   router: PropTypes.object.isRequired,
// }

export default withRouter(DetailsPane)
